import { Field } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import PhoneInput from 'react-phone-input-2';
import FormControl from './FormControl';
import { Typography } from '@mui/material';

const FormPhoneInput = ({
  disabled = false,
  name = 'phone',
  label = undefined,
  noMarginBottom = undefined,
}) => {
  const { t } = useTranslation();
  return (
    <FormControl
      label={label ?? t('Phone number')}
      style={{ marginBottom: noMarginBottom ? 0 : undefined }}
    >
      <Field name={name}>
        {({ input, meta }) => (
          <>
            <PhoneInput
              {...input}
              disabled={disabled}
              country={'fr'}
              inputStyle={{
                width: '100%',
                height: 40,
                borderRadius: 5,
              }}
              buttonStyle={{
                background: 'white',
                borderTopLeftRadius: 5,
                borderBottomLeftRadius: 5,
                borderRight: 'none',
              }}
            />

            {meta.touched && (meta.error || meta.submitError) ? (
              <Typography
                color="error"
                sx={{
                  fontWeight: 400,
                  fontSize: '0.75rem',
                  lineHeight: 1.66,
                  textAlign: 'left',
                  marginTop: '4px',
                  marginRight: '14px',
                  marginBottom: 0,
                  marginLeft: '14px',
                }}
              >
                {meta.touched && (t(meta.error) || t(meta.submitError))}
              </Typography>
            ) : null}
          </>
        )}
      </Field>
    </FormControl>
  );
};

export default FormPhoneInput;
